import styled from 'styled-components';
import * as React from 'react';

export const StatsBlock = styled.div`
  border: 1px solid ${p => p.theme.color.lightGrey};
  border-radius: ${p => p.theme.borderRadius.default};
  color: ${p => p.theme.borderRadius.red};
  background-color: ${p => p.theme.color.paleGreyTwo};
  display: flex;
  flex-direction: column;
`;

interface WatsonStatsBlockProps {
  title: string;
  className?: string;
  children?: React.ReactNode;
}

const WatsonStatsTitle = styled.span`
  font-size: 14px;
  color: ${p => p.theme.color.battleshipGrey};
  margin-bottom: 23px;
`;

const WatsonStatsBlock = (props: WatsonStatsBlockProps) => {
  return (
    <StatsBlock className={props.className}>
      <WatsonStatsTitle>{props.title}</WatsonStatsTitle>
      {props.children}
    </StatsBlock>
  );
};

export const WatsonStatsBlockStyled = styled(WatsonStatsBlock)`
  flex-grow: 1;
  padding: 23px 35px;
`;



// WEBPACK FOOTER //
// ./src/containers/Stats/Components/Common.tsx